import { SELECTED_FUNDING_AREA, SELECTED_PROGRAM } from "../../../../ducks/fundingArea";
import {
  clearCharts,
  downloadIndicatorCSV,
  getTimeFacetForEvaluation,
  INDICATOR_GROUP_ID,
  INDICATOR_GROUPS,
  INDICATORS,
  LABEL,
  loadIndicatorGroupData,
  loadIndicatorGroups,
  PROGRAM_ID_LIST,
  PROGRAM_INSTANCE_FOREIGN_IDS,
  PROGRAM_SELECTION,
  propertyChange,
  RECEIVED_TIME_FACET,
  removeDataForAnalyticsReport,
  yearsChange
} from "../../../../ducks/indicatorGroup";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ROLES } from "../../../../ducks/login";
import { getCsv } from "../../../../ducks/report";
import Charts from "./Charts";

const mapStateToProps = (state) => {
  return {
    indicatorGroups: state.indicatorGroup[INDICATOR_GROUPS],
    programInstanceForeignIds: state.indicatorGroup[PROGRAM_INSTANCE_FOREIGN_IDS],
    indicators: state.indicatorGroup[INDICATORS],
    groupId: state.indicatorGroup[INDICATOR_GROUP_ID],
    timeFacet: state.indicatorGroup[RECEIVED_TIME_FACET],
    selectedFundingArea: state.fundingArea[SELECTED_FUNDING_AREA],
    selectedProgram: state.fundingArea[SELECTED_PROGRAM],
    label: state.indicatorGroup[LABEL],
    programSelection: state.indicatorGroup[PROGRAM_SELECTION],
    programIdList: state.indicatorGroup[PROGRAM_ID_LIST],
    roles: state.login[ROLES]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      loadIndicatorGroups,
      loadIndicatorGroupData,
      clearCharts,
      propertyChange,
      yearsChange,
      getCsv,
      getTimeFacetForEvaluation,
      removeDataForAnalyticsReport,
      downloadIndicatorCSV
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Charts);
